import type { CountryCode } from 'libphonenumber-js';
import { parsePhoneNumber, isValidPhoneNumber } from 'libphonenumber-js';

export class PhoneService {
  /**
   * Formats a phone number to E164 format or returns undefined if invalid
   */
  formatToE164(phoneNumber: string, defaultCountry: CountryCode = 'AE'): string | undefined {
    try {
      if (!isValidPhoneNumber(phoneNumber, defaultCountry)) {
        return undefined;
      }
      const parsedNumber = parsePhoneNumber(phoneNumber, defaultCountry);
      return parsedNumber.format('E.164');
    } catch (error) {
      return undefined;
    }
  }

  /**
   * Validates if a phone number is valid
   */
  isValid(phoneNumber: string, defaultCountry?: CountryCode): boolean {
    try {
      return isValidPhoneNumber(phoneNumber, defaultCountry);
    } catch (error) {
      return false;
    }
  }

  /**
   * Gets phone number information including country, type, etc.
   */
  getPhoneNumberInfo(phoneNumber: string, defaultCountry?: CountryCode) {
    try {
      if (!isValidPhoneNumber(phoneNumber, defaultCountry)) {
        return null;
      }
      const parsedNumber = parsePhoneNumber(phoneNumber, defaultCountry);
      return {
        country: parsedNumber.country,
        countryCallingCode: parsedNumber.countryCallingCode,
        nationalNumber: parsedNumber.nationalNumber,
        type: parsedNumber.getType(),
        formatE164: parsedNumber.format('E.164'),
        formatInternational: parsedNumber.formatInternational(),
        formatNational: parsedNumber.formatNational(),
      };
    } catch (error) {
      return null;
    }
  }
}

export const phoneService = new PhoneService();
